import ClientNotesFormWrapper from "../../../../../clientNotes/ClientNotesFormWrapper.jsx";
import AssociateAppointments from "../../../../../Documents/associate-appointments/index.jsx";
import Appointments from "../../../components/Appointments";
import Injuries from "../../../components/Injuries";
import Providers from "../../../components/Providers";
import Referrals from "../../../components/Referrals";
import { ClientDemographicsForm } from "../../clientDemographics";

import Contacts from "./Contacts.jsx";
import DataEntryCases from "./DataEntryCases";
import DocumentUpload from "./DocumentUpload";
import { ModuleForm } from "./ModuleForm";
import { ModulePrimitiveForm } from "./ModulePrimitiveForm";

const RenderQuestion = ({
  question,
  index,
  sectionId,
  questionKey,
  handleAnswerChange,
  setEnableSave,
  resetValues,
  appointmentLocked = false,
}) => {
  const { question: label, data, required, module, schema, readOnly } = question;

  if (module === "disposition_point") {
    const serviceSchema = schema?.[schema.expected_input];
    const opt = serviceSchema?.properties?.option;
    if (opt) {
      serviceSchema.properties = {
        ...serviceSchema.properties,
        option: {
          ...opt,
          required: required,
          typeProperties: {
            ...(opt.typeProperties || {}),
            searchable: true,
          },
        },
      };
    }
  }

  // ================================
  // Add as much "questions" as you need
  // ================================
  switch (module) {
    case "client_injuries":
      return (
        <Injuries
          key={index}
          sectionId={sectionId}
          label={label}
          data={data}
          schema={schema}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
        />
      );

    case "client_appointment_status":
      return (
        <Appointments
          key={index}
          columns={[
            "provider_name",
            "provider_type",
            "appointment_date",
            "appointment_time",
            "status",
          ]}
          data={data?.map((item) => {
            const providerVal = readOnly?.appointments[item?.id];
            if (providerVal) {
              return {
                ...item,
                provider_name: providerVal?.provider_name,
                provider: providerVal?.provider_id,
                appointment_date: providerVal?.appointment_date,
                appointment_time: providerVal?.appointment_time,
              };
            }
            return item;
          })}
          editableFields={appointmentLocked ? [] : ["provider_type", "status"]}
          label={label}
          schema={schema}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          setEnableSave={setEnableSave}
        />
      );

    case "client_appointment":
      return (
        <Appointments
          key={index}
          columns={["provider", "provider_type", "appointment_date", "appointment_time", "status"]}
          data={data}
          editableFields={appointmentLocked ? [] : ["all"]}
          label={label}
          schema={schema}
          sectionId={sectionId}
          showAddButton={!appointmentLocked}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          setEnableSave={setEnableSave}
          resetValues={resetValues}
        />
      );

    case "client_providers":
      return (
        <Providers
          key={index}
          data={data}
          providersList={readOnly?.provider_display}
          label={label}
          handleAnswerChange={handleAnswerChange}
          questionKey={questionKey}
        />
      );

    case "client_referral":
      return (
        <Referrals
          key={index}
          currentReferrals={readOnly?.current_referrals}
          label={label}
          schema={schema}
          sectionId={sectionId}
          showAddButton
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          setEnableSave={setEnableSave}
        />
      );

    case "action_item_date":
    case "client_communication_preference":
    case "text":
    case "provider_current_balance":
    case "disposition_point":
      return (
        <ModulePrimitiveForm
          moduleName={module}
          key={index}
          schema={schema}
          data={data}
          label={label}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          placeholder={readOnly?.question_placeholder}
          subTitle={readOnly?.sub_header}
          footer={readOnly?.footer_text}
          readOnly={readOnly}
        />
      );
    case "client_demographics":
      return (
        <ClientDemographicsForm
          key={index}
          schema={schema}
          data={data}
          label={label}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          placeholder={readOnly?.question_placeholder}
          subTitle={readOnly?.sub_header}
          footer={readOnly?.footer_text}
          readOnly={readOnly}
          setEnableSave={setEnableSave}
        />
      );

    case "client_coverage":
    case "client_policy":
    case "case_details":
      return (
        <ModuleForm
          key={index}
          schema={schema}
          data={data}
          label={label}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          placeholder={readOnly?.question_placeholder}
          subTitle={readOnly?.sub_header}
          footer={readOnly?.footer_text}
        />
      );

    case "docs_missing_data":
      return (
        <DataEntryCases key={index} label={label} module={module} data={readOnly?.provider_list} />
      );

    case "doc_with_appointment":
      return (
        <AssociateAppointments
          appointments={data}
          title={label}
          schema={schema}
          readOnly={readOnly}
          questionKey={questionKey}
          handleAnswerChange={handleAnswerChange}
          setEnableSave={setEnableSave}
        />
      );

    case "upload_with_disposition":
      return (
        <DocumentUpload
          buttonLabel={readOnly?.document?.button_label}
          data={data}
          handleAnswerChange={handleAnswerChange}
          hasDisposition
          label={label}
          preAuthUrl={readOnly?.document["pre-auth-url"]}
          questionKey={questionKey}
          schema={schema}
        />
      );

    case "document_upload":
      return (
        <DocumentUpload
          buttonLabel={readOnly?.button_label}
          data={data}
          handleAnswerChange={handleAnswerChange}
          label={label}
          preAuthUrl={readOnly["pre-auth-url"]}
          questionKey={questionKey}
        />
      );

    case "case_notes":
      return <ClientNotesFormWrapper data={readOnly?.records || []} questionKey={questionKey} />;

    case "case_contacts":
      return <Contacts data={readOnly.records} questionKey={questionKey} />;
    default:
      return null;
  }
};

export default RenderQuestion;
